export const APIName = {
  auth: {
    signIn: "user/login",
    forgetPassword: {
      verifyEmail: "User/VerifyRetrievalEmail",
      verifyCode: "User/VerifyRetrievalCode",
    },
    checkAuth: "User/isAuthenticated",
  },
  personalInformation: {
    changePassword: "user/UpdatePassword",
    getUserProfile: "user/GetUserDetails",
    updateProfile: "user/UpdatePersonalInformation",
  },
  currency: {
    list: "Lookup/CurrencyList",
    updateCurrency: "User/UpdateUserCurrency",
  },
  budgetTypes: "Lookup/BudgetTypeList",
  countries: "Lookup/CountryList",
  socialMediaLinks: "Lookup/SocialMediaLinkList",
  companyDetails: {
    usersList: "user/GetUsersByAccountId",
    activation: "user/ChangeUserStatus",
    getPermissions: "UserRolePermission/GetBuyerPermissions",
    getUserPermissionsForEdit: "UserRolePermission/GetBuyerUserPermissions",
  },
  vessels: {
    create: "vessel/create",
    update: "vessel/update",
    vesselList: "vessel/GetAll",
    AllvesselList: "vessel/GetVesselListByClientId",
    vessel: "vessel/GetDetails",
    activate: "vessel/ChangeStatus",
    getVesselsForUser: "Vessel/GetUserVessels",
  },
  companyInformation: {
    details: "account/GetAccountDetails",
    updateCompanyInformation: "account/Update",
  },
  financial: {
    getFinancial: "account/GetAccountFees",
    updateFinancial: "account/UpdateAccountFees",
    paymentTerms: "PaymentTerms/GetPaymentTerms",
  },
  client: {
    validateClient: {
      email: "Account/ValidateEmailAddress",
      name: "Account/ValidateCompanyName",
      userEmail: "User/ValidateEmailAddress",
    },
    contact: "Client/ContactUs",
    addClient: "account/Create",
    getAllClients: "Account/GetClients",
    getClient: "Account/GetAccountDetails",
    updateClient: "Account/Update",
    activate: "Account/ChangeStatus",
    customerSupport: "sendEmail/customerSupportEmail",
    contract: {
      addContract: "ClientContract/CreateClientContract",
      getContracts: "ClientContract/GetClientContract",
      editContract: "ClientContract/EditClientContract",
      changeStatus: "ClientContract/ChangeContractStatus",
      deleteContract: "ClientContract/DeleteContract",
    },
  },
  role: {
    list: "Role/GetMarihubTeamRoles",
  },
  user: {
    create: "User/Create",
    getByRole: "User/GetUsersByRoleCode",
    update: "User/UpdateUser",
    activate: "User/ChangeUserStatus",
    verifyUser: "User/VerifyUser",
    setPassword: "User/SetPassword",
    logout: "User/Logout",
    userDetails: "User/GetUserDetailsForShopAs",
    HelpRequest: "User/RequestHelp",
  },
  port: {
    add: "Port/Create",
    getAll: "Port/GetAll",
    getDetails: "Port/GetDetails",
    update: "Port/Update",
    activate: "Port/ChangeStatus",
    financialUpdate: "Port/UpdateFinInfo",
    getPortsForMarihub: "Port/GetAllPortsForMarihub",
    allPorts: "vendor/GetVendorsWithoutPagination",
    vendor: {
      getVendorsInPort: "PortVendor/GetPortVendors",
      assignVendor: "PortVendor/AssignVendorToPort",
      deleteAssignVendor: "PortVendor/RemoveAssignedPortVendor",
    },
  },
  vendor: {
    getAll: "Vendor/GetVendors",
    add: "Vendor/CreateVendor",
    edit: "Vendor/UpdateVendor",
    getVendor: "Vendor/GetVendorById",
    changeStatus: "Vendor/ChangeStatus",
    fees: "Vendor/UpdateVendorFinancial",
    assign: "PortVendor/AssignPortToVendor",
    getAssignedPorts: "PortVendor/GetVendorPorts",
    supplierList: "Vendor/ListSuppliers",
    getAllVendors: "vendor/GetVendorsWithoutPagination",
    getVendorsForAssign: "vendor/GetVendorsForAssign",
    products: {
      categoryList: "ProductVendor/GetVendorCategories",
      products: "ProductVendor/GetVendorAssignedProducts",
      productDetails: "ProductVendor/GetAssignedProductDetails",
      editCost: "ProductVendor/EditCost",
      changeStatus: "ProductVendor/ChangeStatus",
      unassign: "ProductVendor/UnAssignProductToVendor",
    },
  },
  category: {
    getMainCategories: "Category/GetMainCategories",
    getCategories: "Category/GetAllByParentId",
    getPaginatedCategories: "Category/GetPaginatedByParentId",
    getAllCategories: "Category/GetAllCategories",
    addCategory: "Category/Create",
    getCategoryDetails: "Category/GetDetails",
    updateCategory: "Category/Update",
    deleteCategory: "Category/Delete",
    breadCrumb: "Category/BuildCategoryBreadCrumb",
    tree: "Category/GetCategoryTree",
    getFirstLevel: "Category/GetFirstLevelCategory",
  },
  products: {
    getAll: "Product/GetProductListForProcurment",
    addProduct: "Product/Create",
    getProduct: "Product/GetDetails",
    exportCatalog: "Product/ExportCatalogProducts",
    editProduct: "Product/Update",
    editProducts: "Product/UpdateProductsCategories",
    discount: {
      getProductDiscount: "MarihubProductDiscount/GetDiscountByProductId",
      addDiscount: "MarihubProductDiscount/AddDiscount",
    },
    changeStatus: "Product/ChangeProductStatus",
    assignProductVendor: "ProductVendor/AssignProductToVendor",
    getProductForShop: "Product/GetShopProductDetails",
    getProductForCatalog: "Product/GetShopProductDetailsInCatalog",
    getProductSuppliers: "Product/GetProductSuppliers",
    contract: {
      contractedClients: "ClientContract/GetContractedClients",
      addProductToContract: "ClientContract/AssignContractProduct",
      detectContract: "ClientContract/CheckIfClientHasContract",
      getAllContracts: "clientcontract/GetAllActiveContracts",
    },
    addPreferredSupplier: "Product/AddPreferredSupplier",
    editPreferredSupplier: "Product/EditPreferredSupplier",
  },
  brand: {
    list: "Lookup/GetBrands",
  },
  unit: {
    list: "Lookup/GetUnits",
  },
  nutritionalFacts: {
    list: "Lookup/GetNutritionalFacts",
  },
  brandShop: {
    list: "Brand/ListBrands",
  },
  shop: {
    products: "Product/GetProductListForBuyer",
    productsMarihub: "Product/GetProductListForMarihub",
    getRange: "Product/GetPriceRange",
  },
  accounts: {
    companies: "Account/GetClients",
    getEmployeesInCompany: "User/GetBuyerUsers",
    getClientsForShoppingAs: "Client/GetClientListForShopAs",
    getUsersListForShopAs: "User/GetUsersListForShopAs",
    clientsForMarihub: "client/GetAllClientsForMarihub",
    vesselClients: "Vessel/GetVesselListByClientId",
  },
  order: {
    importItems: "Order/ImportOrderItems",
    addItem: "Order/AddOrderItem",
    replaceItem: "Order/ReplaceOrderItem",
    deleteItem: "Order/DeleteOrderItem",
    createOrder: "Order/SaveOrder",
    addOrderItem: "Order/SaveOrderItems",
    deleteOrder: "Order/DeleteOrder",
    changeOrderStatus: "Order/ChangeOrderStatus",
    budget: {
      update: "Order/UpdateOrderBudget",
    },
    orderDetails: {
      comments: {
        addComment: "OrderComment/AddOrderComment",
        commentsList: "OrderComment/GetOrderComments",
        singleComment: "OrderComment/GetOrderCommentById",
        editComment: "OrderComment/EditOrderComment",
        deleteComment: "OrderComment/DeleteOrderComment",
      },
      items: {
        categories: "Order/GetOrderCategories",
        itemList: "Order/GetOrderItems",
        supplierList: "Order/GetOrderSuppliers",
        exportExcelSheet: "Export/ExcelExportOrderItems",
        getMissingItemCountAndPrice: "Order/GetOrderMissingSuplierItemsInfo",
        requestedItems: {
          list: "RequestedItem/GetOrderRequestedItems",
        },
      },
      activities: {
        list: "OrderActivity/GetOrderActivity",
      },
      duplicateOrder: {
        createReorder: "Order/DuplicateOrder",
      },
    },
    shareOrder: "Order/ShareOrder",
    orderSummary: "Order/GetConfirmOrderSummary",
    orderUserPermissions: "Order/GetUserPermissionsForOrder",
    orderItems: "Order/GetOrderItems",
    myOrderList: "Order/GetOrderList",
    getUserDraftedOrders: "Order/GetUserDraftedOrders",
    orderData: "Order/GetOrderBasicInformation",
    markAllAsDelivered: "Order/MarkAllAsDelivered",
    markShipmentAllAsDelivered: "Order/MarkShipmentAsDelivered",
    orderStatus: "Order/GetOrderStatuses",
    oneOrderSummary: "Order/GetOrderSummary",
    purchaseOrder: "Order/UpdateOrder",
    editDateRange: "Order/EditDeliveryDate",
    orderPort: "Order/EditDeliveryLocation",
    allOrderDetails: "Order/GetOrderDetailsInJson",
    allOrderList: "Order/GetOrderListInJson",
    updateItem: "Order/UpdateOrderItem",
    editProcessingFees: "Order/EditOrderProcessingFees",
    automaticallyAssignSupplier: "Order/AutomaticallyAssignSupplier",
    rateOrder: "Order/RateOrder",
    deliveryDocuments: {
      list: "OrderAttachment/GetDeliveryDocuments",
      confirmPODs: "Order/ConfirmAllPODs",
    },
    invoicesDocuments: {
      list: "OrderAttachment/GetInvoices",
    },
  },
  orderStatus: {
    client: "OrderStatus/GetStatusForClient",
    sales: "OrderStatus/GetStatusForSales",
    logistics: "OrderStatus/GetStatusForLogistics",
  },
  attachments: {
    list: "OrderAttachment/GetAttachmentDocumentTypes",
    create: "OrderAttachment/CreateDocument",
    edit: "OrderAttachment/UpdateDocument",
    getDocument: "OrderAttachment/GetDocumentById",
    deleteDocument: "OrderAttachment/DeleteDocument",
    vendor: {
      add: "Vendor/CreateDocument",
      getAll: "Vendor/GetDocuments",
      delete: "Vendor/DeleteDocument",
      getDocument: "Vendor/GetDocumentById",
      editDocument: "Vendor/UpdateDocument",
    },
    client: {
      add: "Client/CreateDocument",
      getAll: "Client/GetDocuments",
      delete: "Client/DeleteDocument",
      getDocument: "Client/GetDocumentById",
      editDocument: "Client/UpdateDocument",
    },
  },
  logistics: {
    orderList: "Logistics/GetOrderList",
    shipments: {
      list: "Shipment/GetOrderShipments",
      missingItems: "Shipment/GetMissingShipment",
      missingShipments: {
        list: "Shipment/GetMissingShipmentItems",
        missingOrderList: "Order/GetOrderMissingItems",
        addSupplierItem: "Order/AddSupplierToMissingItem",
      },
      collectingItems: {
        list: "Shipment/GetShipmentItems",
        markAllAsPickedUp: "Order/MarkAllAsPickedUp",
        updatePickedUpOrderItems: "Order/UpdatePickedUpOrderItems",
        exportDN: "Export/ExportDelvieryNoteInJson",
      },
    },
  },
  lookUp: {
    paymentTerms: "PaymentTerms/GetPaymentTerms",
  },
  clientContract: {
    basicInfo: "ClientContract/GetContractBasicInfo",
    contractedItems: {
      contractedItemsCategory: "ClientContract/GetContractedCategories",
      contractedItems: "ClientContract/GetContractProductList",
      editItemPrice: "ClientContract/EditContractProduct",
      removeContractedItem: "ClientContract/RemoveContractedProduct",
    },
  },
  systemNotification: {
    list: "notify",
    markNotify: "SystemNotification/MarkAsRead",
  },
  supplier: {
    list: "vendor/GetSuppliersList",
    orderConfirmation: {
      generateToken: "SupplierToken/GetSupplierPageUrl",
      orderDetails: "Order/GetOrderDetailsForPricing",
      updateCost: "SupplierToken/UpdateSupplierCost",
      downloadSupplier: "SupplierToken/DownloadSupplierOrderXLS",
      uploadFile: "SupplierToken/UploadSupplierOrderXLS",
      tokenForCatalog: "SupplierToken/GetSupplierPageForCatalog",
    },
  },
  reports: {
    clientOrders: "reporting/clientOrderStats",
  },
  brands: {
    getBrandsList: "Brand/GetBrandList",
    getBrandDetails: "Brand/GetBrandByID",
    addBrand: "Brand/AddBrand",
    updateBrand: "Brand/UpdateBrand",
    deleteBrand: "Brand/DeleteBrand",
  },
};
